import React, { useState } from 'react';
import { useCurrency } from '../contexts/CurrencyContext';
import { PLANS } from '../config/pricing';

const ReferralLanding = ({ referralCode, onSignUp }) => {
  const [hoveredPlan, setHoveredPlan] = useState(null);
  const { formatPrice } = useCurrency();

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#0f0a1e 0%,#1a1145 30%,#0d1b3e 60%,#0f0a1e 100%)',color:'#fff',fontFamily:'-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif'}}>
      {/* Hero Section */}
      <div style={{textAlign:'center',padding:'60px 20px 40px',position:'relative',overflow:'hidden'}}>
        <div style={{position:'absolute',top:'-50%',left:'-20%',width:'140%',height:'200%',background:'radial-gradient(circle at 50% 30%,rgba(139,92,246,0.12),transparent 60%)',pointerEvents:'none'}}></div>
        
        <div style={{position:'relative',zIndex:1}}>
          <div style={{display:'inline-flex',alignItems:'center',gap:'12px',padding:'8px 20px',background:'rgba(139,92,246,0.15)',borderRadius:'40px',border:'1px solid rgba(139,92,246,0.25)',marginBottom:'24px'}}>
            <span style={{fontSize:'16px'}}>🎁</span>
            <span style={{color:'#a78bfa',fontSize:'13px',fontWeight:'700',letterSpacing:'0.5px'}}>YOU'VE BEEN INVITED</span>
          </div>
          
          <h1 style={{fontSize:'clamp(28px,5vw,48px)',fontWeight:'900',margin:'0 0 16px',lineHeight:'1.1',background:'linear-gradient(135deg,#fff 0%,#c4b5fd 50%,#06b6d4 100%)',WebkitBackgroundClip:'text',WebkitTextFillColor:'transparent'}}>
            Turn Long Videos Into<br/>Viral Short Clips
          </h1>
          
          <p style={{color:'#94a3b8',fontSize:'clamp(14px,2vw,18px)',maxWidth:'600px',margin:'0 auto 32px',lineHeight:'1.6'}}>
            Your friend thinks you'd love VlogClip AI. Sign up for a paid plan and you'll <span style={{color:'#10b981',fontWeight:'700'}}>both earn a bonus video credit</span>.
          </p>
          
          <div style={{display:'inline-flex',alignItems:'center',gap:'8px',padding:'10px 20px',background:'rgba(16,185,129,0.1)',borderRadius:'12px',border:'1px solid rgba(16,185,129,0.2)'}}>
            <span style={{color:'#10b981',fontSize:'14px',fontWeight:'700'}}>{'🎉 Referral Code: ' + referralCode}</span>
          </div>
        </div>
      </div>

      {/* How It Works */}
      <div style={{maxWidth:'800px',margin:'0 auto',padding:'0 20px 50px'}}>
        <h2 style={{textAlign:'center',fontSize:'22px',fontWeight:'800',marginBottom:'30px',color:'#e2e8f0'}}>How It Works</h2>
        <div style={{display:'flex',gap:'16px',flexWrap:'wrap',justifyContent:'center'}}>
          {[
            { step: '1', icon: '📝', title: 'Sign Up', desc: 'Create your account in seconds' },
            { step: '2', icon: '💳', title: 'Choose a Plan', desc: 'Subscribe to Pro or Business' },
            { step: '3', icon: '🎁', title: 'Both Get Rewarded', desc: 'You and your friend each get +1 bonus video credit' }
          ].map((s, i) => (
            <div key={i} style={{flex:'1',minWidth:'200px',padding:'24px 20px',background:'rgba(255,255,255,0.03)',borderRadius:'16px',border:'1px solid rgba(255,255,255,0.06)',textAlign:'center',position:'relative'}}>
              <div style={{width:'32px',height:'32px',borderRadius:'50%',background:'linear-gradient(135deg,#8b5cf6,#06b6d4)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'14px',fontWeight:'800',margin:'0 auto 12px'}}>{s.step}</div>
              <div style={{fontSize:'24px',marginBottom:'8px'}}>{s.icon}</div>
              <div style={{color:'#fff',fontSize:'15px',fontWeight:'700',marginBottom:'4px'}}>{s.title}</div>
              <div style={{color:'#64748b',fontSize:'13px'}}>{s.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Plans Section */}
      <div style={{maxWidth:'900px',margin:'0 auto',padding:'0 20px 60px'}}>
        <h2 style={{textAlign:'center',fontSize:'22px',fontWeight:'800',marginBottom:'8px',color:'#e2e8f0'}}>Choose Your Plan</h2>
        <p style={{textAlign:'center',color:'#64748b',fontSize:'14px',marginBottom:'30px'}}>Referral bonus applies to paid plans only</p>
        
        <div style={{display:'flex',gap:'16px',flexWrap:'wrap',justifyContent:'center'}}>
          {/* Pro Plan */}
          <div 
            onMouseEnter={() => setHoveredPlan('pro')}
            onMouseLeave={() => setHoveredPlan(null)}
            style={{flex:'1',minWidth:'260px',maxWidth:'380px',padding:'28px 24px',background: hoveredPlan === 'pro' ? 'rgba(139,92,246,0.08)' : 'rgba(255,255,255,0.03)',borderRadius:'20px',border: hoveredPlan === 'pro' ? '2px solid rgba(139,92,246,0.4)' : '2px solid rgba(255,255,255,0.06)',transition:'all 0.3s',cursor:'pointer'}}
          >
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
              <span style={{color:'#a78bfa',fontSize:'12px',fontWeight:'700',textTransform:'uppercase',letterSpacing:'1px'}}>Creator Pro</span>
              <span style={{padding:'4px 12px',borderRadius:'20px',background:'rgba(139,92,246,0.15)',color:'#a78bfa',fontSize:'11px',fontWeight:'700'}}>POPULAR</span>
            </div>
            <div style={{marginBottom:'20px'}}>
              <span style={{fontSize:'36px',fontWeight:'900',color:'#fff'}}>{formatPrice(PLANS.pro.price.monthly)}</span>
              <span style={{color:'#64748b',fontSize:'14px'}}>/month</span>
            </div>
            <div style={{display:'flex',flexDirection:'column',gap:'10px',marginBottom:'24px'}}>
              {['20 videos per month (+1 bonus)', '100 clips per month', '1080p HD quality output', 'No watermarks', 'Priority processing', 'Batch processing'].map((f, i) => (
                <div key={i} style={{display:'flex',alignItems:'center',gap:'8px',color: i === 0 ? '#10b981' : '#cbd5e1',fontSize:'13px',fontWeight: i === 0 ? '700' : '500'}}>
                  <span style={{color:'#10b981',fontSize:'14px'}}>✓</span> {f}
                </div>
              ))}
            </div>
            <button onClick={() => onSignUp('pro')} style={{width:'100%',padding:'14px',borderRadius:'12px',border:'none',background:'linear-gradient(135deg,#8b5cf6,#7c3aed)',color:'#fff',fontSize:'15px',fontWeight:'700',cursor:'pointer',transition:'all 0.2s'}}>
              Get Started with Pro
            </button>
          </div>

          {/* Business Plan */}
          <div
            onMouseEnter={() => setHoveredPlan('business')}
            onMouseLeave={() => setHoveredPlan(null)}
            style={{flex:'1',minWidth:'260px',maxWidth:'380px',padding:'28px 24px',background: hoveredPlan === 'business' ? 'rgba(6,182,212,0.08)' : 'rgba(255,255,255,0.03)',borderRadius:'20px',border: hoveredPlan === 'business' ? '2px solid rgba(6,182,212,0.4)' : '2px solid rgba(255,255,255,0.06)',transition:'all 0.3s',cursor:'pointer'}}
          >
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
              <span style={{color:'#06b6d4',fontSize:'12px',fontWeight:'700',textTransform:'uppercase',letterSpacing:'1px'}}>Business</span>
              <span style={{padding:'4px 12px',borderRadius:'20px',background:'rgba(6,182,212,0.15)',color:'#06b6d4',fontSize:'11px',fontWeight:'700'}}>BEST VALUE</span>
            </div>
            <div style={{marginBottom:'20px'}}>
              <span style={{fontSize:'36px',fontWeight:'900',color:'#fff'}}>{formatPrice(PLANS.business.price.monthly)}</span>
              <span style={{color:'#64748b',fontSize:'14px'}}>/month</span>
            </div>
            <div style={{display:'flex',flexDirection:'column',gap:'10px',marginBottom:'24px'}}>
              {['60 videos per month (+1 bonus)', '480 clips per month', '1080p HD quality output', 'Custom branding', 'API access', 'White-label options'].map((f, i) => (
                <div key={i} style={{display:'flex',alignItems:'center',gap:'8px',color: i === 0 ? '#10b981' : '#cbd5e1',fontSize:'13px',fontWeight: i === 0 ? '700' : '500'}}>
                  <span style={{color:'#10b981',fontSize:'14px'}}>✓</span> {f}
                </div>
              ))}
            </div>
            <button onClick={() => onSignUp('business')} style={{width:'100%',padding:'14px',borderRadius:'12px',border:'none',background:'linear-gradient(135deg,#06b6d4,#0891b2)',color:'#fff',fontSize:'15px',fontWeight:'700',cursor:'pointer',transition:'all 0.2s'}}>
              Get Started with Business
            </button>
          </div>
        </div>
      </div>

      {/* Trust Section */}
      <div style={{textAlign:'center',padding:'0 20px 60px',maxWidth:'600px',margin:'0 auto'}}>
        <div style={{display:'flex',justifyContent:'center',gap:'30px',flexWrap:'wrap',marginBottom:'20px'}}>
          {[
            { icon: '🔒', text: 'Secure payments' },
            { icon: '⚡', text: 'Instant access' },
            { icon: '❌', text: 'Cancel anytime' }
          ].map((t, i) => (
            <div key={i} style={{display:'flex',alignItems:'center',gap:'6px'}}>
              <span>{t.icon}</span>
              <span style={{color:'#64748b',fontSize:'13px',fontWeight:'500'}}>{t.text}</span>
            </div>
          ))}
        </div>
        <p style={{color:'#475569',fontSize:'12px'}}>
          By signing up, you agree to our Terms of Service. Referral bonus is credited when you subscribe to a paid plan.
        </p>
      </div>
    </div>
  );
};

export default ReferralLanding;
